module.exports = __webpack_public_path__ + "media/images/sp/top/keyword_family-56a37a1ccd2557d58ef3fffd09150bae.webp";